import { useLocale } from "../i18n/useLocale";
import { FeedbackForm } from "./FeedbackForm";
import { InfoPageContent } from "./InfoPageContent";
import { Modal } from "./Modal";
import { IconButton } from "./IconButton";

export function InfoPageModal({ pageId, onClose, page }) {
  const { display } = useLocale();
  if (!page) return null;

  return (
    <Modal
      titleId="info-modal-title"
      onClose={onClose}
      className="info-modal"
      backdropClassName="modal-backdrop info-modal-backdrop"
      header={(
        <div className="info-modal-header">
          <div>
            <p className="info-page-kicker">{page.kicker}</p>
            <h2 id="info-modal-title">{page.title}</h2>
          </div>
          <IconButton label={display.t("web.shell.closeNotice")} onClick={onClose}>×</IconButton>
        </div>
      )}
    >
      <div className="info-modal-body">
        <InfoPageContent pageId={pageId} page={page} />
        {pageId === "feedback" && <FeedbackForm />}
      </div>
    </Modal>
  );
}
